import React, { useCallback, useRef, useState } from 'react';

export const Context = React.createContext<{ loading: boolean; setLoading: (value: boolean) => void }>({
  loading: false,
  setLoading: () => {},
});

export const PageLoaderContextProvider = (props: React.PropsWithChildren) => {
  const [, setState] = useState({});
  const ref = useRef(false);
  const setLoading = useCallback((value: boolean) => {
    ref.current = value;
    setState({});
  }, []);
  return <Context.Provider value={{ setLoading, loading: ref.current }}>{props.children}</Context.Provider>;
};
